import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

// The single source of truth for primary navigation. The desktop rail shows
// every entry; the mobile bottom bar shows the ones flagged `mobile`.
export const NAV_ITEMS = [
  {
    key: 'capture',
    label: 'Capture',
    path: '/capture',
    icon: PhotoCameraOutlinedIcon,
    mobile: true,
    match: (p) => p.startsWith('/capture'),
  },
  {
    key: 'market',
    label: 'Market',
    path: '/market',
    icon: StorefrontOutlinedIcon,
    mobile: true,
    match: (p) => p === '/market' || p === '/listings' || p.startsWith('/listing/'),
  },
  {
    key: 'inventory',
    label: 'Inventory',
    path: '/inventory',
    icon: Inventory2OutlinedIcon,
    mobile: true,
    match: (p) => p.startsWith('/inventory') || p === '/sell',
  },
  {
    key: 'buy',
    label: 'Buy',
    path: '/buy',
    icon: ShoppingCartOutlinedIcon,
    mobile: true,
    match: (p) => p.startsWith('/buy') || p.startsWith('/lists') || p.startsWith('/shared-list'),
  },
  {
    key: 'services',
    label: 'Services',
    path: '/services',
    icon: HandymanOutlinedIcon,
    mobile: true,
    match: (p) => p.startsWith('/services'),
  },
  {
    key: 'orders',
    label: 'Orders',
    path: '/orders',
    icon: LocalShippingOutlinedIcon,
    mobile: false,
    match: (p) => p.startsWith('/orders') || p.startsWith('/cart') || p.startsWith('/checkout') || p.startsWith('/payment'),
  },
];

export function activeNavKey(pathname) {
  const p = String(pathname || '/');
  return NAV_ITEMS.find((item) => item.match(p))?.key || '';
}

// Which assistant "section" a route belongs to. Drives the placeholder in the
// top search bar and tells the server which intent defaults apply.
export function sectionForPath(pathname) {
  const p = String(pathname || '/');
  if (p === '/market' || p === '/listings' || p.startsWith('/listing/')) return 'market';
  if (p.startsWith('/inventory') || p === '/sell') return 'inventory';
  if (p.startsWith('/buy') || p.startsWith('/lists') || p.startsWith('/shared-list')) return 'buy';
  if (p.startsWith('/services')) return 'services';
  if (p.startsWith('/capture')) return 'capture';
  if (p.startsWith('/orders') || p.startsWith('/cart') || p.startsWith('/checkout')) return 'orders';
  if (p.startsWith('/profile')) return 'profile';
  return 'home';
}

export function assistantPlaceholder(section, { authed = false } = {}) {
  if (!authed) return 'Search the market';
  switch (section) {
    case 'market':
      return 'Search the market, or ask needL';
    case 'inventory':
      return 'Search inventory, or say "add 3 paint rollers"';
    case 'buy':
      return 'Add something to buy, or say "find milk"';
    case 'services':
      return 'What needs fixing? Or a service you offer';
    case 'capture':
      return 'Search market, inventory, or things to buy';
    case 'orders':
      return 'Ask about an order, or search';
    default:
      return 'Search market, inventory, buy, or services';
  }
}
